import { render, staticRenderFns } from "./veStuGraduationJyzbhRuleShow.vue?vue&type=template&id=705c23f2&scoped=true"
import script from "./veStuGraduationJyzbhRuleShow.vue?vue&type=script&lang=js"
export * from "./veStuGraduationJyzbhRuleShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c23f2",
  null
  
)

export default component.exports